import React from 'react';
import { useWaitlistCount } from '../hooks/useWaitlistCount';
import { PartyPopper } from 'lucide-react';
import { WAITLIST_GOAL } from '../lib/tiers';

interface WaitlistStatsProps {
  className?: string;
}

export function WaitlistStats({ className = '' }: WaitlistStatsProps) {
  const { count, loading, isAnimating, name: currentTier, spots: remainingSpots } = useWaitlistCount();
  const progress = (count / WAITLIST_GOAL) * 100;

  return (
    <div className={className}>
      <div className="flex items-center justify-between text-sm mb-2">
        <span className="font-medium text-gray-700">Utvecklingsstart</span>
        <span className="font-medium text-blue-600">
          {loading ? '...' : `${Math.round(progress)}% klart`}
        </span>
      </div>
      <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
        <div 
          className={`h-full bg-blue-600 rounded-full transition-all duration-500 ${
            isAnimating ? 'animate-pulse' : ''
          }`}
          style={{ width: `${progress}%` }}
        />
      </div>
      <div className="mt-3 flex justify-between items-center text-sm">
        <span className="text-gray-500">
          {loading ? 'Laddar...' : (
            <span className={`transition-all duration-300 ${isAnimating ? 'text-blue-600 font-medium scale-110' : ''}`}>
              {count} av {WAITLIST_GOAL} anmälda
              {isAnimating && (
                <PartyPopper className="inline-block ml-2 animate-bounce" size={16} />
              )}
            </span>
          )}
        </span>
        {remainingSpots > 0 && (
          <span className="text-blue-600 font-medium">
            {remainingSpots} {currentTier}-platser kvar
          </span>
        )}
      </div>
    </div>
  );
}